<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
        <div class="row p-1">
            <div class="mt-3 col-12 col-md-6">
                <FormInput label="Cantidad de códigos de invitación a generar" type="number" name="cantidad_codigos" id="cantidad_codigos" rules="required" v-model="categoria.cantidad_codigos" />
            </div>
            <div class="mt-3 col-12 col-md-6">
                <FormInput label="Número de usos por código" type="number" name="usos" id="usos" rules="required" v-model="categoria.usos" />
            </div>
            <div class="col-12">
                <button type="submit" id="generar_codigos" class="btn btn-primary mb-3" target="blank">Guardar</button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
export default {
    props: ['cantidad_codigos', 'usos'],
    data() {
        return {
            categoria: {
                usos: this.usos,
                cantidad_codigos: this.cantidad_codigos
            }
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.$emit('terminado', this.categoria.usos, this.categoria.cantidad_codigos);
            }
        }
    }
}
</script>